var render, staticRenderFns
import script from "./XrkSubtitle.vue?vue&type=script&lang=js&"
export * from "./XrkSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./XrkSubtitle.vue?vue&type=style&index=0&id=9cce6964&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cce6964",
  null
  
)

export default component.exports